import React, { useState } from "react";
import { useEffect, useMemo } from "react";
import { GRAPH_TYPES, REPORT_TYPES } from "../../../../constants/app-constant";
import { formatWidgetParams } from "../../../../utility/common-methods";
import { CustomBSDropdown } from "../../../Shared";
import { Widget } from "../Widget";

export default function AnalysisWidget({
  widgetParams,
  applyFilterTS,
  twitterFeeds = false,
  topicId,
  endRange,
  startRange,
  selectedPieEntity,
  tonality,
  twitterBreakDownPie,
  twitterBreakDownLine,
  keyMetrics,
  twitterMetricsData,
  tabData,
  widgetApiInProgress,
  embededEnabled,
}) {
  const chartTypes =
    (widgetParams.filterOption &&
      Object.keys(widgetParams.filterOption).map((val) => ({
        label: val,
        value: val,
      }))) ||
    [];
  const [selectedFilter, setSelectedFilter] = useState(
    chartTypes &&
      widgetParams.filterOption &&
      widgetParams.filterOption[chartTypes[0]] &&
      widgetParams.filterOption[chartTypes[0]][0]
  );
  //console.log(selectedFilter);
  const [selectedChartType, setSelectedChartType] = useState(
    chartTypes && chartTypes[0]
  );

  const { type, filterOption = {}, report_type } = widgetParams;
  const optList =
    selectedChartType && Array.isArray(filterOption[selectedChartType.label])
      ? filterOption[selectedChartType.label].filter(
          (el) => el.vertical.indexOf(type) !== -1
        )
      : [];

  const widget = useMemo(() => {
    return formatWidgetParams({
      ...widgetParams,
      report_type: selectedFilter && selectedFilter.value,
      chartType: selectedChartType && selectedChartType.value,
    });
  }, [selectedFilter, widgetParams]);

  useEffect(() => {
    console.log("Updating Chart Type in Analysis Widget");
    // console.log(widgetParams.filterOption);
    widgetParams.filterOption &&
      selectedFilter !==
        widgetParams.filterOption[selectedChartType.label][0] &&
      setSelectedFilter(widgetParams.filterOption[selectedChartType.label][0]);
    // if (!widgetParams.chartType && selectedChartType) {
    //   widgetParams.chartType = selectedChartType.label;
    //   console.log(widgetParams.chartType);
    // }
  }, [selectedChartType]);

  useEffect(() => {
    const globalChartType = widgetParams.chartType;
    let idx = -1;
    chartTypes.forEach((elm, i) => {
      if (elm.label === globalChartType) {
        idx = i;
      }
    });
    if (idx !== -1) {
      setSelectedFilter(widgetParams.filterOption[chartTypes[idx].label][0]);
      setSelectedChartType(chartTypes[idx]);
    }
  }, [widgetParams.chartType]);

  const fullWidthReports = selectedFilter && /city/i.test(selectedFilter.value);

  const showFilters = optList && optList.length > 1;
  const showChartTypes = chartTypes && chartTypes.length > 0;

  const ReportFilter = () => (
    <CustomBSDropdown
      config={{
        name: "report type",
        options: optList,
      }}
      selectedItem={selectedFilter}
      onSelect={setSelectedFilter}
      hideAllOption
    />
  );

  const ChartFilter = () => (
    <CustomBSDropdown
      config={{
        name: "chart type",
        options: chartTypes,
      }}
      selectedItem={selectedChartType}
      onSelect={setSelectedChartType}
      hideAllOption
    />
  );

  const renderAnalysisWidget = () => {
    if (!showFilters && !showChartTypes) {
      return;
    } else if (showFilters && !showChartTypes) {
      return <ReportFilter />;
    } else {
      return (
        <>
          <ReportFilter />
          <ChartFilter />
        </>
      );
    }
  };

  return (
    <div
      className={`analysisChartWrapper ${type}-`}
      style={fullWidthReports ? { width: "100%" } : {}}
    >
      {selectedFilter && widget && (
        <Widget
          key={`analysis-widget-${type}-${report_type}`}
          Journalist
          isAnalysisReport
          widget={widget}
          applyFilterTS={applyFilterTS}
          renderAnalysisWidget={renderAnalysisWidget}
          twitterFeeds={twitterFeeds}
          topicId={topicId}
          startRange={startRange}
          endRange={endRange}
          selectedFilter={selectedPieEntity}
          tonality={tonality}
          twitterBreakDownPie={twitterBreakDownPie}
          twitterBreakDownLine={twitterBreakDownLine}
          keyMetrics={keyMetrics}
          twitterMetricsData={twitterMetricsData}
          tabData={tabData}
          widgetApiInProgress={widgetApiInProgress}
          optList={optList}
          selectedChartType={selectedChartType}
          setSelectedChartType={setSelectedChartType}
          embededEnabled={embededEnabled}
        />
      )}
    </div>
  );
}
